import {EventBus} from "../../events";

const state = {
    translations: {},
};
const actions = {
    // updated() {
    //     EventBus.$emit('filter_updated');
    // }
};
const mutations = {
    setFromJsonString(state, json) {
        state.translations = JSON.parse(json.replace(/\n/g, "\\n"));
    },
};
const getters = {
    get: (state) => (key) => {
        return state.translations[key] || `No Translation for: ${key}`;
    }
};

export const label = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
